


export const dejarTresDecimales = (number) => {
    const num = Number(number);
    if (isNaN(num)) return 0;
    return Number(num.toFixed(3));
};




export const separadorMillares = ( numero ) => {
    const num = Number(numero);
    if (isNaN(num)) return 0;
    return numero.toLocaleString('es-CO');
}